<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<p class="mt-4 text-body-2">
				<!-- TODO -->
				棚卸し対象：{{ inventory.inventory_type_i18n | formatType }}
				<br />
				棚卸し月：{{ inventory.month }}月
				<br />
				実施日：{{ common.formatLocalDate(inventory.created_at) }}
			</p>
			<template v-if="approval_authority_flag && inventory.situation === 'pending'">
				<v-row class="mt-4" no-gutters justify="center">
					<v-alert max-width="600px" outlined type="warning" color="red" prominent>
						<p class="text-body-2 mx-sm-4 mx-2">
							このは棚卸し結果は、<strong>承認待ち</strong>となっています。
							<br />
							承認、または、却下を行ってください。
						</p>
						<v-row class="mt-4" no-gutters justify="space-around">
							<v-btn color="secondary" @click="confirmDeliveryOrder()">
								<v-icon class="mr-1"> mdi-check-circle-outline</v-icon>
								承認
							</v-btn>
							<v-menu v-model="menu" :close-on-content-click="false">
								<template v-slot:activator="{ on, attrs }">
									<v-btn color="red" dark v-bind="attrs" v-on="on">
										<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
										却下
									</v-btn>
								</template>

								<v-card width="400px" class="top-border-menu top-border-menu--red">
									<v-form ref="form" v-model="valid" class="pa-2">
										<v-textarea
											class="mt-4"
											v-model="reason"
											label="却下理由"
											:rules="[rules.required]"
											hint="却下理由は作成者へメッセージとして送信されます。"
											outlined
											required
										/>
									</v-form>
									<v-card-actions class="ma-0">
										<v-row no-gutters justify="space-around">
											<v-btn
												color="red"
												:dark="valid"
												@click="rejectInventory()"
												:disabled="!valid"
											>
												<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
												却下
											</v-btn>
											<v-btn text @click="menu = false"> キャンセル </v-btn>
										</v-row>
									</v-card-actions>
								</v-card>
							</v-menu>
						</v-row>
					</v-alert>
				</v-row>
			</template>
			<template v-else-if="inventory.situation == 'pending'">
				<v-row class="mt-4" no-gutters justify="center">
					<v-alert max-width="600px" outlined type="warning" color="red" prominent>
						<p class="mtext-body-2 mx-sm-4 mx-2">
							このは棚卸し結果は、<strong>承認待ち</strong>となっています。
							<br />
							確定ではないのでご注意ください
						</p>
					</v-alert>
				</v-row>
			</template>

			<v-row no-gutters justify="space-between" align="center">
				<h5 class="text-h6 font-weight-bold">{{ formatMonth() }}</h5>
			</v-row>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="carry_overs"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr
							:class="isAuthorized ? '' : 'no-click'"
							@click="isAuthorized ? openEditDialog(item) : false"
						>
							<td>{{ formatName(item) }}</td>
							<td>
								{{ item.quantity }}
							</td>
							<td>{{ item.user.full_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
		<CarryOverEditDialog
			:dialog.sync="dialog"
			:selectedCarryOver="selectedCarryOver"
			:inventory_type="inventory.inventory_type"
			:inventory="inventory"
			@close="closeEditDialog"
			@update-carry-over="updateCarryOver($event)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CarryOverEditDialog from "./components/CarryOverEditDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		CarryOverEditDialog,
	},
	filters: {
		formatType(inventory_type) {
			if (!inventory_type) return
			return inventory_type.replace("在庫", "")
		},
	},
	data() {
		return {
			title: "棚卸し結果一覧表",
			authority_flag: false,
			approval_authority_flag: false,

			id: this.$route.params.id,
			inventory: {},
			carry_overs: [],
			quantity_type: null,
			selectedCarryOver: null,
			dialog: false,
			headers: [
				{
					text: "名称",
					value: "name",
					width: "200px",
				},
				{
					text: "結果",
					value: "result",
					width: "200px",
				},
				{
					text: "確認者",
					value: "user",
					width: "150px",
				},
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},

			menu: false,
			reason: null,
			valid: false,

			common,
			rules,
			moment,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchCarryOvers(page)
	},
	methods: {
		fetchCarryOvers(page) {
			const params = { page }
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories/${this.id}`
			axios
				.get(url, {
					params,
					headers,
				})
				.then((res) => {
					this.inventory = res.data.inventory
					this.carry_overs = res.data.carry_overs
					this.pagination = res.data.pagination
					this.authority_flag = res.data.authority_flag
					this.approval_authority_flag = res.data.approval_authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		confirmDeliveryOrder() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories/approvals`
			let params = {
				inventories: {
					id: this.inventory.id,
				},
			}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "申請を承認しました。",
					})
					this.inventory.situation = res.data.inventory.situation
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		rejectInventory() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories/approvals`
			let params = {
				reason: this.reason,
				inventories: {
					id: this.inventory.id,
				},
			}
			axios
				.delete(url, {
					headers,
					params,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "alert",
						text: "申請を却下しました。",
					})
					this.inventory.situation = res.data.inventory.situation
					this.resetRejectCard()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		resetRejectCard() {
			this.menu = false
			this.reason = null
		},
		openEditDialog(carry_over) {
			if (!this.isInCurrentMonth) return
			this.selectedCarryOver = {...carry_over}
			this.dialog = true
		},
		isInCurrentMonth() {
			let currentDate = moment()

			return this.inventory.month.isSame(currentDate, "month")
		},
		closeEditDialog() {
			this.dialog = false
			this.selectedCarryOver = null
		},
		updateCarryOver(carry_over) {
			let item = this.carry_overs.find((c) => c.id == carry_over.id)
			if (!item) return
 			item.quantity = carry_over.quantity;
		},
		formatName(carry_over) {
			if (carry_over.target_type == "OrderIndividualInfo") {
				return carry_over.target.ordered_product.product.name
			} else if (carry_over.target_type == "OrderComponent") {
				if (carry_over.target.ordered_product) {
				return carry_over.target.component.name + `(製造番号 : ${carry_over.target.ordered_product.product_number})`
			}
			} else {
				return carry_over.target.name
			}
		},
		formatMonth() {
			if (!this.inventory.year || !this.inventory.month) return ""
			return this.inventory.year + "年" + this.inventory.month + "月"
		},
		getPage(page) {
			this.fetchCarryOvers(page)
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
	},
	computed: {
		isAuthorized() {
			return (
				this.authority_flag &&
				this.inventory.inventory_type !== "product_order_individual_info" &&
				this.inventory.inventory_type !== "wip_order_individual_info"
			)
		},
	},
}
</script>
